import type { BoxComponent } from '../types/box';

export const boxes = new Map<string, BoxComponent>();
